import { IconButton } from "@mui/material";
import moment from "moment";
import Iconify from "components/iconify/Iconify";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

export const chaptercolumns = ({
  openPopover,
  handleOpenPopover,
  setSpeedLearnInfo,
  paginationpage,
}) => {
  const columnValues = [
    {
      name: "Sr. No.",
      selector: (row, index) =>
        paginationpage === 1
          ? index + 1
          : index === 9
          ? `${paginationpage}0`
          : `${paginationpage - 1}${index + 1}`,
      width: "80px",
    },
    {
      name: "Image",
      selector: (row) => {
        return (
          <img
            src={row.thumbnail}
            alt="logo"
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "40px",
              objectFit: "cover",
            }}
          />
        );
      },
      width: "100px",
    },
    {
      name: "Goal Title",
      cell: (row) => {
        return (
          <Tooltip title={row?.goalTitle}>
            <Typography component="div" noWrap sx={{ fontSize: "14px" }}>
              {row?.goalTitle}
            </Typography>
          </Tooltip>
        );
      },
      width: "200px",
    },
    {
      name: "Subject Name",
      cell: (row) => {
        return (
          <Tooltip title={row?.subjectName}>
            <Typography component="div" noWrap sx={{ fontSize: "14px" }}>
              {row?.subjectName}
            </Typography>
          </Tooltip>
        );
      },
      width: "130px",
    },
    {
      name: "Topic Name",
      cell: (row) => {
        return (
          <Tooltip title={row?.masteTopic}>
            <Typography component="div" noWrap sx={{ fontSize: "14px" }}>
              {row?.masteTopic}
            </Typography>
          </Tooltip>
        );
      },
      width: "160px",
    },
    {
      name: "Video Title",
      cell: (row) => {
        return (
          <Tooltip title={row?.title}>
            <Typography component="div" noWrap sx={{ fontSize: "14px" }}>
              {row?.title}
            </Typography>
          </Tooltip>
        );
      },
      width: "180px",
    },
    {
      name: "Video Url",
      cell: (row) => {
        return (
          <Tooltip title={row?.video}>
            <Typography component="div" noWrap sx={{ fontSize: "14px" }}>
              {row?.video}
            </Typography>
          </Tooltip>
        );
      },
      width: "180px",
    },
    {
      name: "Sequence",
      selector: (row) => row?.ORDERSEQ,
      width: "100px",
    },
    {
      name: "Created Date",
      selector: (row) => moment(row.createdAt).format("DD MMM YYYY"),
      width: "140px",
    },
    {
      name: "Actions",
      selector: (row) => {
        return (
          <IconButton
            color={openPopover ? "inherit" : "default"}
            onClick={(e) => {
              handleOpenPopover(e);
              setSpeedLearnInfo(row);
            }}
          >
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        );
      },
    },
  ];
  return columnValues;
};
